export const CONTACT = {
  email: "contact@wosteldjerba.com",
  phone: "+216 58 710 007",
  whatsapp: "https://wa.me/21658710007",
  whatsappPretty: "wa.me/21658710007",
  instagram: "https://instagram.com/wosteldjerba",
  facebook: "https://facebook.com/wosteldjerba",
  sefertunisia: "https://sefertunisia.com",
  mainGoogleMaps: "https://maps.app.goo.gl/Mi2CssD8DZRFfWas8",
  mainCoords: { lat: 33.8076, lng: 10.8451 }, // Djerba center fallback
};

export const TYPE_META = {
  hostel:      { logo: "https://customer-assets.emergentagent.com/job_djerba-hostel/artifacts/ptcpaan3_13.png", color: "#1FB6D9", colorClass: "bg-wostel-cyan", textClass: "text-wostel-cyan", bgSoft: "#E5F8FD" },
  guest_house: { logo: "https://customer-assets.emergentagent.com/job_djerba-hostel/artifacts/z4b6woyo_15.png", color: "#7FA88B", colorClass: "bg-wostel-sage", textClass: "text-wostel-sage", bgSoft: "#EBF2EC" },
  apartment:   { logo: "https://customer-assets.emergentagent.com/job_djerba-hostel/artifacts/b5nedmwz_14.png", color: "#1E3A8A", colorClass: "bg-wostel-navy", textClass: "text-wostel-navy", bgSoft: "#E5EAF6" },
};

export const TYPE_KEYS = ["hostel", "guest_house", "apartment"];
